"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeNoMoreAbilityHandler = exports.BeNoMoreActorAbilityFactory = exports.BeNoMoreAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
class BeNoMoreAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BeNoMore;
        this.__typeName = "BeNoMore";
    }
}
exports.BeNoMoreAbilityArgs = BeNoMoreAbilityArgs;
let BeNoMoreActorAbilityFactory = class BeNoMoreActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BeNoMore", "AllEnemies", 2);
    }
};
BeNoMoreActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BeNoMore")
], BeNoMoreActorAbilityFactory);
exports.BeNoMoreActorAbilityFactory = BeNoMoreActorAbilityFactory;
let BeNoMoreAbilityHandler = class BeNoMoreAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                const targets = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
                targets.forEach(targetId => container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Permanent,
                    effect: new core_1.FadeEffectArgs()
                }));
            }
        });
    }
};
BeNoMoreAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BeNoMore)
], BeNoMoreAbilityHandler);
exports.BeNoMoreAbilityHandler = BeNoMoreAbilityHandler;
